export const locale = {
    lang: 'nl',
    data: {
        'OVERZICHT': {
            'FILTERAFDELING': 'Filter op een afdeling',
            'FILTERTEXT': 'Filter op text'
        },
    }
};
